package team.platforma.aicombo.di

import org.koin.core.context.startKoin
import org.koin.dsl.KoinAppDeclaration
import org.koin.dsl.module
import team.platforma.auth_di.getAuthModules
import team.platforma.chat_data.ChatDBFactory
import team.platforma.chat_di.chatDiProvider
import team.platforma.chatdata.database.ChatDatabase
import team.platforma.dictionary_data.database_factory.DictionaryDBFactory
import team.platforma.dictionary_di.dictionaryDiProvider
import team.platforma.dictionarydata.database.DictionaryDatabase
import team.platforma.module_network.di.networkModule


class AppDI {
    fun initKoinMobile(config: KoinAppDeclaration? = null) {

        startKoin {
            config?.invoke(this)
            modules(
                networkModule
                        + dictionaryDiProvider()
                        + chatDiProvider()
                        + getAuthModules()
            )
        }
    }

    suspend fun initKoinWeb(config: KoinAppDeclaration? = null) {
        val dictionaryDatabase = DictionaryDBFactory().web()
        val chatDatabase = ChatDBFactory().web()

        startKoin {
            config?.invoke(this)
            modules(
                networkModule
                        + databaseWebModule(
                    dictionaryDatabase,
                    chatDatabase
                )
                        + dictionaryDiProvider()
                        + chatDiProvider()
                        + getAuthModules()
            )
        }
    }

    private fun databaseWebModule(
        dictionaryDatabase: DictionaryDatabase?,
        chatDatabase: ChatDatabase?
    ) = module {
        dictionaryDatabase?.let { database ->
            single { database }
        }
        chatDatabase?.let { database ->
            single { database }
        }
    }
}
